import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { A11yNotice, useA11yDispatcher, useCustomizeValues } from "@devowl-wp/customize";
import { __ } from "../../utils/i18n.js";
const CustomizeA11yOverlay = ({ settings })=>{
    const values = useCustomizeValues(settings);
    const hasError = useMemo(()=>{
        const { [settings[0]]: { value: type }, [settings[1]]: { value: overlay }, [settings[2]]: { value: overlayBgAlpha } } = values;
        if (type === "banner") {
            return false;
        }
        return !overlay || overlayBgAlpha < 50;
    }, [
        JSON.stringify(values)
    ]);
    useA11yDispatcher({
        setting: settings[1],
        valid: !hasError
    });
    if (hasError === false) {
        return null;
    }
    return /*#__PURE__*/ _jsx(A11yNotice, {
        severity: "warning",
        text: __('We recommend to show an overlay until consent and an overlay opacity over 50 %% to comply with the {{aPerc}}"perceptibility" of the WCAG 2.2 standard{{/aPerc}} and thereby meet the {{aEuMinimum}}EU\'s minimum legal requirements for accessibility{{/aEuMinimum}}.')
    });
};
export { CustomizeA11yOverlay };
